import { combineReducers } from 'redux';

import activityReducer from './ducks/activity';
import deviceReducer from './ducks/devices';
import filtersReducer from './ducks/filters';
import groupDetailsReducer from './ducks/group-details';
import groupsReducer from './ducks/groups';
import invitationsReducer from './ducks/invitations';
import organizationReducer from './ducks/organization';
import selectedUsersReducer from './ducks/selected-users';
import teamDetailsReducer from './ducks/team-details';
import teamManagementReducer from './ducks/team-management';
import teamsReducer from './ducks/teams';
import teamsViewReducer from './ducks/teams-view';
import userDetailsReducer from './ducks/user-details';
import usersReducer from './ducks/users';
import usersViewReducer from './ducks/users-view';

const reducers = {
  activity: activityReducer,
  devices: deviceReducer,
  filters: filtersReducer,
  groupDetails: groupDetailsReducer,
  groups: groupsReducer,
  invitations: invitationsReducer,
  main: teamManagementReducer,
  organization: organizationReducer,
  selectedUsers: selectedUsersReducer,
  teamDetails: teamDetailsReducer,
  teams: teamsReducer,
  teamsView: teamsViewReducer,
  userDetails: userDetailsReducer,
  users: usersReducer,
  usersView: usersViewReducer,
};

export default combineReducers(reducers);
